import { Component, type CSSProperties, type ErrorInfo, type ReactNode } from "react";

interface Props {
  children: ReactNode;
}

interface State {
  error: Error | null;
}

export class ErrorBoundary extends Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Argus frontend render error", error, info.componentStack);
  }

  render() {
    if (!this.state.error) return this.props.children;

    return (
      <main style={st.page} role="alert">
        <div style={st.panel}>
          <h1 style={st.title}>No se pudo cargar Argus</h1>
          <p style={st.copy}>
            La sesión local del navegador quedó en un estado inválido. Recarga la página para volver a intentar.
          </p>
          <button
            type="button"
            style={st.button}
            onClick={() => {
              window.sessionStorage.clear();
              window.location.reload();
            }}
          >
            Recargar y limpiar sesión
          </button>
        </div>
      </main>
    );
  }
}

const st: Record<string, CSSProperties> = {
  page: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: 24,
    boxSizing: "border-box",
    background: "#F7F4EC",
    color: "#13343B",
    fontFamily: "system-ui, -apple-system, Segoe UI, Roboto, sans-serif",
  },
  panel: {
    width: "min(100%, 420px)",
    border: "1px solid #DED7C5",
    borderRadius: 8,
    background: "#fff",
    padding: 24,
    boxShadow: "0 18px 50px rgba(19, 52, 59, 0.08)",
  },
  title: {
    margin: "0 0 10px",
    fontSize: 22,
    lineHeight: 1.2,
  },
  copy: {
    margin: "0 0 18px",
    fontSize: 15,
    lineHeight: 1.45,
    color: "#4A5A5F",
  },
  button: {
    width: "100%",
    border: 0,
    borderRadius: 6,
    background: "#0F6B6E",
    color: "#fff",
    fontWeight: 700,
    padding: "12px 14px",
    cursor: "pointer",
  },
};
